import * as React from 'react';
import { ISelectDropdownItem, SelectDropdown } from './SelectDropdown';
import { SelectField } from './SelectField';

export interface ISelectDropdownProps {
  value: number | string;
  items: ISelectDropdownItem[];
  modalTitle: string;
  modalHeader?: React.ReactNode;
  onItemClick(id: number | undefined): void;
}

export function Select({
  value,
  items,
  modalTitle,
  modalHeader,
  onItemClick,
}: ISelectDropdownProps): React.JSX.Element {
  const [isOpened, setOpenedState] = React.useState(false);

  const onFieldClick = React.useCallback(() => setOpenedState(true), [setOpenedState]);
  const onDropdownClose = React.useCallback(() => setOpenedState(false), [setOpenedState]);
  const onSelectItemClick = React.useCallback(
    (id: number | undefined) => {
      setOpenedState(false);
      onItemClick(id);
    },
    [setOpenedState, onItemClick],
  );

  return (
    <>
      <SelectField value={value} onClick={onFieldClick} />
      {isOpened && (
        <SelectDropdown
          title={modalTitle}
          header={modalHeader}
          items={items}
          onClose={onDropdownClose}
          onItemClick={onSelectItemClick}
        />
      )}
    </>
  );
}
